import { ButtonProps } from "react-bootstrap";
import { ITestableComponentProps } from "../../shared/types/testing.types";

export interface IButtonProps extends ITestableComponentProps, ButtonProps {
  label?: string;
}

export const DefaultButtonProps = {
  label: undefined,
};
